const trust = [
  { icon: "ri-vip-crown-2-fill", title: "官网直发", desc: "安装包来自官方渠道，杜绝第三方改包" },
  { icon: "ri-shield-star-line", title: "下载即检", desc: "入库前完成病毒与签名双重校验" },
  { icon: "ri-eye-off-line", title: "隐私不打扰", desc: "无诱导授权，不读取无关敏感权限" },
  { icon: "ri-speed-up-line", title: "极速提速", desc: "全国多节点分发，大版本也能秒传" },
];

export default function SafeTrust() {
  return (
    <section className="bg-accent-500 py-12 md:py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-md">
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-accent-100">
              <i className="ri-shield-check-fill"></i>
              SAFE FIRST
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-background-50 md:text-3xl">
              安心下载，是我们发车的第一站
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-50">
              四个原则写进每个安装包的质检流程，下载不担心，安装不费心。
            </p>
          </div>

          <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:w-auto lg:max-w-xl">
            {trust.map((t) => (
              <div key={t.title} className="flex items-start gap-3 rounded-xl bg-accent-600/40 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-50/90 text-accent-700">
                  <i className={`${t.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-background-50">{t.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-accent-50">{t.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}